<template>
  <div class="payment-method-input clearfix">
    <div class="form-group row">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <template v-if="options.methods.length > 1">
          <div class="btn-group">
            <button v-for="method in options.methods"
              class="btn"
              :class="{
                'btn-primary': method === chosenMethod,
                'btn-primary disabled': method !== chosenMethod
              }"
              @click="chooseMethod(method)"
              type="button">
              <span class="fa fa-fw" v-if="method.icon" :class="method.icon"></span>
              {{ method.label }}
            </button>
          </div>
        </template>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-sm-12">
        <component v-if="chosenMethod"
          :is="chosenMethod.type + '-input'"
          :options="chosenMethod"
          ref="component"
          @input="validate($event)"
          :value="value.uuid">
        </component>
      </div>
    </div>
  </div>
</template>

<script>
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'
import ObjectSelectInput from '@/components/inputs/ObjectSelectInput'

export default {
  name: 'PaymentMethodInput',
  components: {
    ObjectSelectInput
  },
  props: {
    value: {
      type: Object,
      default () {
        return {
          uuid: '',
          type: 'stripe'
        }
      }
    },
    options: {
      type: Object,
      default () {
        return {
          label: 'Text',
          name: 'object_select',
          methods: [],
          objectName: 'fullName',
          titleName: 'organizationName',
          value: '',
          objects: [],
          required: false
        }
      }
    }
  },
  data () {
    return {
      required: this.options.required,
      chosenMethod: false,
      isDirty: false,
      isValid: false
    }
  },
  computed: {
    label () {
      return this.options.singleLabel
        ? this.options.singleLabel
        : this.options.label
    },
    validationClass,
    validationIcon,
    validationMessage
  },
  mounted () {
    if (this.options.methods.length < 2) {
      this.chosenMethod = this.options.methods[0]
    } else {
      this.chosenMethod = this.options.methods.find(el => (el.value === this.value.uuid || el.paymentMethod === this.value.type))
    }
  },
  methods: {
    async chooseMethod (method) {
      method.required = this.required
      this.chosenMethod = method
      await this.$nextTick()
    },
    validate (val = this.value.uuid) {
      let value = {
        uuid: val,
        type: this.chosenMethod.paymentMethod
      }
      this.$emit('input', value)
      if (this.required) {
        this.isDirty = true
        this.isValid = value.uuid.length > 0
      } else {
        this.isValid = true
      }
    },
    async runWatcher (name, val) {
      let price = this.$parent.$refs.fields.find(el => el.options.type === 'price-breakdown')
      await this.$nextTick()
      if (price.priceTable) {
        this.required = price.priceTable.priceBreakdown.totalCost > 0
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/PaymentMethodInput.vue